
import React from "react";
import Btn from "../common/Btn";
import BlogCard from "../common/BlogCard";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import SectionHead from "../common/SectionHead";
import styles from "../../assets/style.module.css";
import { IHostBlogArticle } from "../../../../../services";

export interface LatestBlogProps {
    basePath: string;
    articles: IHostBlogArticle[];
    onSelect: (a: IHostBlogArticle) => void;
}

function LatestBlog({ basePath, articles, onSelect }: LatestBlogProps) {

    const labels = i18nManager.Labels.home;

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <SectionHead tag={labels.blog} title={labels.blog_title} action={<Btn variant="outline" size="sm" to={pagePath(basePath, "BLOG")}>{i18nManager.Labels.view_all}</Btn>} />
            <div className={styles["blog-grid"]}>
                {articles.map((a) => (<BlogCard key={a.external_id} article={a} onSelect={onSelect} />))}
            </div>
        </div>
    </section>);
}

export default LatestBlog;
